import { PlanType } from "../../enums/PlanType";
import actions from "./actions";

const initState = {
    plans: [],
    readAllState: null,
    billingCycle: null,

    selectedPlan: null,
    planAddons: [],
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PLAN_READ_ALL_REQUEST:
            return {
                ...state,
                readAllState: 'request',
            };
        case actions.PLAN_READ_ALL_SUCCESS:
            return {
                ...state,
                readAllState: 'success',
                plans: action.plans,
            };
        case actions.PLAN_SET_BILLING_CYCLE:
            return {
                ...state,
                billingCycle: action.billingCycle,
            };
        case actions.PLAN_SET_PLAN: {
            const hasPlan = !!action.plan;
            return {
                ...state,
                selectedPlan: !hasPlan ? action.plan : {
                    ...action.plan,
                    quota_period: action.plan.type === PlanType.ONE || action.plan.type === PlanType.TWO ||
                    action.plan.type === PlanType.ZERO ? "YEARLY" : "MONTHLY",
                },
            };
        }
        case actions.PLAN_SET_ADD_ONS:
            return {
                ...state,
                planAddons: action.planAddons,
            };
        case actions.PLAN_SET_ADD_ON:
            console.log('aaa PLAN_SET_ADD_ON', {
                statePlanAddons: state.planAddons,
                action,
            });
            return {
                ...state,
                planAddons: state.planAddons.map(addOn => {
                    if (addOn.type === action.planAddon.type)
                        return action.planAddon;

                    return addOn;
                }),
            };

        case actions.PLAN_RESET:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
